/** 学会简介页子栏目定义 — 前后台共用 */

export const INTRO_SECTIONS = [
  { id: 'overview', title: '学会概况', kind: 'page', pageCode: 'intro_overview' },
  { id: 'charter', title: '学会章程', kind: 'page', pageCode: 'intro_charter' },
  { id: 'current-leaders', title: '现任领导', kind: 'personnel', personnelGroup: '现任领导' },
  { id: 'former-leaders', title: '历任领导', kind: 'personnel', personnelGroup: '历任领导' },
  { id: 'council', title: '理事会', kind: 'personnel', personnelGroup: '理事会' },
  { id: 'supervisory', title: '监事会', kind: 'personnel', personnelGroup: '监事会' },
  { id: 'secretariat', title: '秘书处', kind: 'personnel', personnelGroup: '秘书处' },
  { id: 'branches', title: '专业分会', kind: 'branches' },
  { id: 'history', title: '历史沿革', kind: 'timeline' },
  { id: 'gallery', title: '历史相册', kind: 'gallery' },
  { id: 'planning', title: '发展规划', kind: 'page', pageCode: 'intro_planning' },
  { id: 'awards', title: '获奖成果', kind: 'awards' }
]

export const INTRO_PAGE_CODES = INTRO_SECTIONS
  .filter(s => !!s.pageCode)
  .map(s => s.pageCode)

export const INTRO_PAGE_LABELS = Object.fromEntries(
  INTRO_SECTIONS.filter(s => s.pageCode).map(s => [s.pageCode, s.title])
)

export const INTRO_PERSONNEL_GROUPS = Array.from(
  new Set(INTRO_SECTIONS.filter(s => s.personnelGroup).map(s => s.personnelGroup))
)

export const INTRO_PAGE_SECTIONS = INTRO_SECTIONS.filter(
  s => s.kind === 'page' && !!s.pageCode
)

export function generateIntroPageCode(title, existingCodes = []) {
  const preset = INTRO_PAGE_SECTIONS.find(s => s.title === String(title || '').trim())
  if (preset && preset.pageCode) return preset.pageCode

  const ascii = String(title || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '')
  let base = ascii.length >= 2 ? `intro_${ascii}` : `intro_${Date.now().toString(36)}`

  let code = base
  let n = 2
  while (existingCodes.includes(code)) {
    code = `${base}_${n++}`
  }
  return code
}

export function isIntroPageCode(code) {
  return String(code || '').startsWith('intro_')
}
